// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","834":"component---src-pages-index-archived-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1423fb8cf775ce484f68","678":"ccacf8f093ad3dbfc763","834":"ca481bdf6242d86e428a","883":"920b32f1594154bed02a"}[chunkId] + ".js";
};